import { Component, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, ResolveEnd, ResolveStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { ProgressBarService } from '@mrm/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  isToggled: boolean;

  constructor(
    private _viewContainerRef: ViewContainerRef,
    private _translateService: TranslateService,
    private _toastrService: ToastrService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _progressBarService: ProgressBarService
  ) {
    // allow the toaster service to target this view container
    // _toastrService.setRootViewContainerRef(_viewContainerRef);
    // _toastrService.onClickToast()
    //   .subscribe(toast => {
    //     if (toast.data && toast.data['refresh'] && toast.data['refresh'] == true) {
    //       _router.navigate([], { queryParams: { reload: true } });
    //       _toastrService.dismissToast(toast);
    //     }
    //   });

    /* intialize translation service */
    const preFileName = 'locale_';
    const canadianCulture = 'CA';
    let currentCulture = _translateService.getBrowserCultureLang().split('-')[0]; // strip out 'en' from 'en-US'

    // force english if not english or french
    if (!['en', 'fr'].some(l => l === currentCulture)) { currentCulture = 'en'; }

    const cultureString = currentCulture + '-' + canadianCulture;

    this._translateService.setDefaultLang(preFileName + cultureString);
    this._translateService.use(preFileName + cultureString);

    // Hack to load all languages
    // If we don't do this, the first time we change language not all elements are properly translated
    // http://stackoverflow.com/questions/38272388/ng2-translate-translation-strings-not-updating-in-components-with-onpush-chang
    this._translateService.reloadLang(preFileName + 'fr-' + canadianCulture); // locale_
    this._translateService.reloadLang(preFileName + cultureString);

    sessionStorage.setItem('currentCulture', cultureString);
    sessionStorage.setItem('preFileName', preFileName);

    _router.events.pipe(filter(e => e instanceof ResolveStart || e instanceof ResolveEnd || e instanceof RouteConfigLoadStart || e instanceof RouteConfigLoadEnd)).subscribe(
      e => {
        // Resolve start/ Lazy load modules start
        if (e instanceof ResolveStart || e instanceof RouteConfigLoadStart) { this._startLoadingScreen(); }
        // Resolve end/ Lazy load modules end
        else if (e instanceof ResolveEnd || e instanceof RouteConfigLoadEnd) { this._stopLoadingScreen(); }
      }
    );
  }

  private _startLoadingScreen() {
    if (!this._progressBarService.loading) {
      this._progressBarService.start();
    }
  }

  private _stopLoadingScreen() {
    if (this._progressBarService.loading) {
      this._progressBarService.stop();
    }
  }
}
